module.exports = __webpack_public_path__ + "media/img/logos/accenture-38681a6cf833a63da2d6f2b80c9c13be.svg";